import { Component, inject, input } from '@angular/core';

import { LossRunReviewViewModel } from '@program-suite/data-common/program';

@Component({
  selector: 'lib-ui-loss-runs-review',
  imports: [],
  templateUrl: './ui-loss-runs-review.component.html',
  styleUrl: './ui-loss-runs-review.component.scss',
})
export class UiLossRunsReviewComponent {
  model = input.required<LossRunReviewViewModel>();
}
